// import moment from 'moment'

export const Native = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    actionHideHelp({ commit }) {
      if (window.Android && window.Android.hideHelp) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.hideHelp
      ) {
        // for iOS
        window.webkit.messageHandlers.hideHelp.postMessage('')
      } else {
        console.log('No ver5_3 found.')
        return window.Android ? 1 : 2
      }
    },
    /**
     * ネイティブ側に歩数データを要求する
     * @param {Object} payload.params
     * @param {String} payload.apiType
     */
    actionReload({ commit }, payload) {
      if (window.Android && window.Android.reloadWalk) {
        // Androidの場合
        window.Android.reloadWalk()
      } else {
        location.reload()
      }
    },
    /**
     * ネイティブ側にAPIToken発行を依頼する
     * @param {Object} payload.params
     * @param {String} payload.apiType
     */
    actionRequestToken({ commit }, payload) {
      if (window.Android && window.Android.requestTokenToNative) {
        // Androidの場合
        window.Android.requestTokenToNative(JSON.stringify(payload))
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestTokenToNative
      ) {
        // iOSの場合
        window.webkit.messageHandlers.requestTokenToNative.postMessage(payload)
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    /**
     * ネイティブにユーザー情報を渡す
     * @param {Object} commit
     * @param {String} payload.userId
     * @param {Boolean} payload.isComplete
     */
    actionSendRegisterParams({ commit }, payload) {
      console.log('nativeに送ります')
      if (window.Android && window.Android.sendRegisterParams) {
        // for Android
        window.Android.sendRegisterParams(JSON.stringify(payload))
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.sendRegisterParams
      ) {
        // for iOS
        window.webkit.messageHandlers.sendRegisterParams.postMessage(payload)
      } else {
        alert('Not viewing in webview')
      }
    },
    /**
     * TermsOfServiceページモーダルを呼び出す
     * @param {Object} commit
     */
    actionCallTermsOfService({ commit }) {
      if (window.Android && window.Android.showTermsOfService) {
        // for Android
        window.Android.showTermsOfService()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showTermsOfService
      ) {
        // for iOS
        window.webkit.messageHandlers.showTermsOfService.postMessage('')
      } else {
        alert('Not viewing in webview 2')
      }
    },
    /**
     * PrivacyPolicyモーダルを呼び出す
     * @param {Object} commit
     */
    actionCallPrivacyPolicy({ commit }) {
      if (window.Android && window.Android.showPrivacyPolicy) {
        // for Android
        window.Android.showPrivacyPolicy()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showPrivacyPolicy
      ) {
        // for iOS
        window.webkit.messageHandlers.showPrivacyPolicy.postMessage('')
      } else {
        alert('Not viewing in webview　33')
      }
    },
    /**
     * ネイティブブラウザを呼び出す
     * @param {Object} commit
     * @param {String} externalURL 外部リンクパス
     */
    actionRequestExternalLink({ commit }, externalURL) {
      if (window.Android && window.Android.requestExternalLink) {
        // for Android
        window.Android.requestExternalLink(externalURL)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestExternalLink
      ) {
        // for iOS
        window.webkit.messageHandlers.requestExternalLink.postMessage(
          externalURL
        )
      } else {
        alert('Not viewing in webview')
      }
    },
    /**
     * クーポン詳細ページを呼び出す
     * @param {commit} commit
     * @param {String} couponId
     */
    actionCallCupon({ commit }, couponId) {
      if (window.Android && window.Android.showCouponDetail) {
        // for Android
        window.Android.showCouponDetail(couponId)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showCouponDetail
      ) {
        // for iOS
        window.webkit.messageHandlers.showCouponDetail.postMessage(
          `${couponId}`
        )
      } else {
        alert('Not viewing in ', couponId)
      }
    },
    /**
     * フリーパス詳細ページを呼び出す
     * @param {commit} commit
     * @param {String} couponId
     */
    actionCallFreepass({ commit }, couponId) {
      if (window.Android && window.Android.showFreepassDetail) {
        // for Android
        window.Android.showFreepassDetail(couponId)
      } else if (window.Android && window.Android.showCouponDetail) {
        window.Android.showCouponDetail(couponId)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showFreepassDetail
      ) {
        // for iOS
        window.webkit.messageHandlers.showFreepassDetail.postMessage(
          `${couponId}`
        )
      } else {
        alert('Not viewing in ', couponId)
      }
    },
    /**
     * クーポン詳細ページを閉じる
     */
    actionCallCloseCoupon({ commit }) {
      if (window.Android && window.Android.closeCouponDetail) {
        // for Android
        window.Android.closeCouponDetail()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closeCouponDetail
      ) {
        // for iOS
        window.webkit.messageHandlers.closeCouponDetail.postMessage('')
      } else {
        alert('Not viewing in wevview')
      }
    },
    /**
     * クーポン詳細ページを呼び出す
     * @param {commit} commit
     * @param {String} newsId
     */
    actionCallNewsDetail({ commit }, newsId) {
      console.log(newsId)
      if (window.Android && window.Android.showNewsDetail) {
        // for Android
        window.Android.showNewsDetail(newsId)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showNewsDetail
      ) {
        // for iOS
        window.webkit.messageHandlers.showNewsDetail.postMessage(`${newsId}`)
      } else {
        alert('Not viewing in ', newsId)
      }
    },
    /**
     * クーポン詳細ページを閉じる
     */
    actionCallCloseNewsDetail({ commit }) {
      if (window.Android && window.Android.closeNewsDetail) {
        // for Android
        window.Android.closeNewsDetail('')
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closeNewsDetail
      ) {
        // for iOS
        window.webkit.messageHandlers.closeNewsDetail.postMessage('')
      } else {
        alert('Not viewing in wevview')
      }
    },
    /**
     * Badge表示
     * @param {Object} param0
     * @param {String} payload '1' or '0'
     */
    actionUnreadChanged({ commit }, payload) {
      if (window.Android && window.Android.unreadChanged) {
        // for Android
        window.Android.unreadChanged(payload)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.unreadChanged
      ) {
        // for iOS
        console.log(payload)
        window.webkit.messageHandlers.unreadChanged.postMessage(payload)
      } else {
        // alert('Not viewing in wevview')
      }
    },
    /**
     * 指定ページへ遷移する
     * @param {Object} param0
     * @param {String} payload
     */
    actionNavigateTo({ commit }, payload) {
      if (window.Android && window.Android.requestNavigateTo) {
        // for Android
        window.Android.requestNavigateTo(payload)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestNavigateTo
      ) {
        window.webkit.messageHandlers.requestNavigateTo.postMessage(payload)
      } else {
        alert('Not viewing in wevview ' + payload)
      }
    },
    /**
     * メーラー表示
     * @param {Object} commit
     */
    actionRequestOpenMail({ commit }) {
      if (window.Android && window.Android.requestOpenMail) {
        // for Android
        window.Android.requestOpenMail()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestOpenMail
      ) {
        window.webkit.messageHandlers.requestOpenMail.postMessage('')
      } else {
        alert('Not viewing in wevview ')
      }
    },
    actionGetScreenShot({ commit }) {
      if (window.Android && window.Android.getScreenShot) {
        // for Android
        window.Android.getScreenShot()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.getScreenShot
      ) {
        // for iOS
        window.webkit.messageHandlers.getScreenShot.postMessage('')
      } else {
        alert('Not viewing in webview　33')
      }
    },
    actionSaveUserId({ commit }, payload) {
      if (window.Android && window.Android.saveUserId) {
        // for Android
        window.Android.saveUserId(payload)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.saveUserId
      ) {
        // for iOS
        window.webkit.messageHandlers.saveUserId.postMessage(`${payload}`)
      } else {
        alert('Not viewing in ', payload)
      }
    },
    actionRequestPassword({ commit }) {
      if (window.Android && window.Android.requestPasswordToNative) {
        // Androidの場合
        window.Android.requestPasswordToNative()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestPasswordToNative
      ) {
        // iOSの場合
        window.webkit.messageHandlers.requestPasswordToNative.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    /**
     * 紹介登録APIのレスポンスをネイティブ側に渡す
     * @param commit
     * @param payload
     */
    actionSendRegisterInvitationData({ commit }, payload) {
      if (window.Android && window.Android.getInvitingMessage) {
        // for Android
        window.Android.getInvitingMessage(JSON.stringify(payload))
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.getInvitingMessage
      ) {
        // for iOS
        window.webkit.messageHandlers.getInvitingMessage.postMessage(payload)
      } else {
        console.log('No native APIs found.')
        alert('Not viewing in ', payload)
      }
    },
    actionCloseInterlude({ commit }) {
      if (window.Android && window.Android.closeInterlude) {
        // for Android
        window.Android.closeInterlude()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closeInterlude
      ) {
        // for iOS
        window.webkit.messageHandlers.closeInterlude.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionClosePremium({ commit }) {
      if (window.Android && window.Android.closePremium) {
        // for Android
        window.Android.closePremium()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closePremium
      ) {
        // for iOS
        window.webkit.messageHandlers.closePremium.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionShowHeader({ commit }) {
      if (window.Android && window.Android.showHeader) {
        // for Android
        window.Android.showHeader()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showHeader
      ) {
        // for iOS
        window.webkit.messageHandlers.showHeader.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionHideHeader({ commit }) {
      if (window.Android && window.Android.hideHeader) {
        // for Android
        window.Android.hideHeader()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.hideHeader
      ) {
        // for iOS
        window.webkit.messageHandlers.hideHeader.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionRequestPaddingTop({ commit }, payload) {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestPaddingTop
      ) {
        // for iOS
        window.webkit.messageHandlers.requestPaddingTop.postMessage(payload)
      } else {
        console.log('No native APIs found.')
      }
    },
    isTarepanda() {
      if (window.Android && window.Android.isTarepanda) {
        // for Android
        return true
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.isTarepanda
      ) {
        // for iOS
        return true
      } else {
        return false
      }
    },
    actionRequestLocationPermIfNeeded() {
      if (window.Android && window.Android.requestLocationPermIfNeeded) {
        // for Android
        window.Android.requestLocationPermIfNeeded()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestLocationPermIfNeeded
      ) {
        // for iOS
      } else {
        console.log('Not viewing in webview')
      }
    },
    actionOpenAboutWalk({ commit }) {
      if (window.Android && window.Android.openAboutWalk) {
        // for Android
        window.Android.openAboutWalk()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.openAboutWalk
      ) {
        // for iOS
        window.webkit.messageHandlers.openAboutWalk.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenWalk({ commit }) {
      if (window.Android && window.Android.openWalk) {
        // for Android
        window.Android.openWalk()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.openWalk
      ) {
        // for iOS
        window.webkit.messageHandlers.openWalk.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenTermsOfUse({ commit }) {
      if (window.Android && window.Android.showTermsOfService) {
        // for Android
        window.Android.showTermsOfService()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showTermsOfService
      ) {
        // for iOS
        window.webkit.messageHandlers.showTermsOfService.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenPrivacyPolicy({ commit }) {
      if (window.Android && window.Android.showPrivacyPolicy) {
        // for Android
        window.Android.showPrivacyPolicy()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showPrivacyPolicy
      ) {
        // for iOS
        window.webkit.messageHandlers.showPrivacyPolicy.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenPrivacyPolicyForLocationInfo({ commit }) {
      if (window.Android && window.Android.showPrivacyPolicy) {
        // for Android
        window.Android.showPrivacyPolicyForLocationInfo()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showPrivacyPolicyForLocationInfo
      ) {
        // for iOS
        window.webkit.messageHandlers.showPrivacyPolicyForLocationInfo.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenDelivery({ commit }) {
      if (window.Android && window.Android.showOpenDelivery) {
        // for Android
        window.Android.showOpenDelivery()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showOpenDelivery
      ) {
        // for iOS
        window.webkit.messageHandlers.showOpenDelivery.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenTakeOut({ commit }) {
      if (window.Android && window.Android.showOpenTakeOut) {
        // for Android
        window.Android.showOpenTakeOut()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showOpenTakeOut
      ) {
        // for iOS
        window.webkit.messageHandlers.showOpenTakeOut.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionOpenNetOrder({ commit }) {
      if (window.Android && window.Android.showOpenNetOrder) {
        // for Android
        window.Android.showOpenNetOrder()
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.showOpenNetOrder
      ) {
        // for iOS
        window.webkit.messageHandlers.showOpenNetOrder.postMessage('')
        return 0
      } else {
        console.log('No native APIs found.')
        return window.Android ? 1 : 2
      }
    },
    actionVer4_1({ commit }) {
      if (window.Android && window.Android.ver4_1) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver4_1
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver4_1 found.')
        return window.Android ? 1 : 2
      }
    },
    actionRequestLineLogin({ commit }) {
      if (window.Android && window.Android.requestLineLogin) {
        // for Android
        window.Android.requestLineLogin()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestLineLogin
      ) {
        // for iOS
        window.webkit.messageHandlers.requestLineLogin.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionLineLoginResult({ commit }, payload) {
      if (window.Android && window.Android.lineLoginResult) {
        // for Android
        window.Android.lineLoginResult(JSON.stringify(payload))
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.lineLoginResult
      ) {
        // for iOS
        window.webkit.messageHandlers.lineLoginResult.postMessage(`${payload}`)
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionVer4_2({ commit }) {
      if (window.Android && window.Android.ver4_2) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver4_2
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver4_2 found.')
        return window.Android ? 1 : 2
      }
    },
    actionVer4_3({ commit }) {
      if (window.Android && window.Android.ver4_3) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver4_3
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver4_3 found.')
        return window.Android ? 1 : 2
      }
    },
    actionCanSIWA({ commit }) {
      if (window.Android && window.Android.canSIWA) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.canSIWA
      ) {
        // for iOS
        window.webkit.messageHandlers.canSIWA.postMessage('')
      } else {
        throw new Error('No native APIs found.')
      }
    },
    actionRequestSIWA({ commit }) {
      if (window.Android && window.Android.requestSIWA) {
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestSIWA
      ) {
        // for iOS
        window.webkit.messageHandlers.requestSIWA.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionAdjustCouponHeight({ commit }, payload) {
      if (window.Android && window.Android.adjustCouponHeight) {
        // for Android
        window.Android.adjustCouponHeight(payload)
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.adjustCouponHeight
      ) {
        // for iOS
        window.webkit.messageHandlers.adjustCouponHeight.postMessage(`${payload}`)
      } else {
        console.log('No native APIs found.')
      }
    },
    actionVer5_2({ commit }) {
      if (window.Android && window.Android.ver5_2) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver5_2
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver5_2 found.')
        return window.Android ? 1 : 2
      }
    },
    actionVer5_3({ commit }) {
      if (window.Android && window.Android.ver5_3) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver5_3
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver5_3 found.')
        return window.Android ? 1 : 2
      }
    },
    actionVer6_0({ commit }) {
      if (window.Android && window.Android.ver6_0) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver6_0
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver6_3 found.')
        return window.Android ? 1 : 2
      }
    },
    actionVer6_1({ commit }) {
      if (window.Android && window.Android.ver6_1) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver6_1
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver6_1 found.')
        return window.Android ? 1 : 2
      }
    },
    actionVer6_3() {
      if (window.Android && window.Android.ver6_3) {
        // for Android
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ver6_3
      ) {
        // for iOS
        return 0
      } else {
        console.log('No ver6_1 found.')
        return window.Android ? 1 : 2
      }
    },
    actionSendAppAccountDelete({ commit }, payload) {
      console.log('nativeに送ります[actionSendAppAccountDelete]')
      if (window.Android && window.Android.sendAppAccountDelete) {
        // for Android
        window.Android.sendAppAccountDelete(JSON.stringify(payload))
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.sendAppAccountDelete
      ) {
        // for iOS
        window.webkit.messageHandlers.sendAppAccountDelete.postMessage(payload)
      } else {
        alert('Not viewing in webview')
      }
    },
    actionRequestSIWAWithAuthCode({ commit }) {
      if (window.Android && window.Android.requestSIWA) {
        return 0
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestSIWAWithAuthCode
      ) {
        // for iOS
        window.webkit.messageHandlers.requestSIWAWithAuthCode.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionRequestInvitationUUID() {
      if (window.Android && window.Android.requestInvitationUUID) {
        window.Android.requestInvitationUUID()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestInvitationUUID
      ) {
        window.webkit.messageHandlers.requestInvitationUUID.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionRemoveInvitationUUID() {
      if (window.Android && window.Android.removeInvitationUUID) {
        window.Android.removeInvitationUUID()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.removeInvitationUUID
      ) {
        window.webkit.messageHandlers.removeInvitationUUID.postMessage('')
      } else {
        console.log('No native APIs found.')
        throw new Error('No native APIs found.')
      }
    },
    actionRequestNeedsCouponTutorial() {
      if (window.Android && window.Android.requestNeedsCouponTutorial) {
        window.Android.requestNeedsCouponTutorial()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.requestNeedsCouponTutorial
      ) {
        window.webkit.messageHandlers.requestNeedsCouponTutorial.postMessage('')
      } else {
        console.log('No native APIs found.')
      }
    },
    actionRequestCloseCouponModal() {
      if (window.Android && window.Android.closeCouponModal) {
        window.Android.closeCouponModal()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closeCouponModal
      ) {
        // for iOS
        window.webkit.messageHandlers.closeCouponModal.postMessage('')
      } else {
        console.log('No native APIs found.')
      }
    },
    actionRequestCloseGachaModal() {
      if (window.Android && window.Android.closeGachaModal) {
        window.Android.closeGachaModal()
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closeGachaModal
      ) {
        // for iOS
        window.webkit.messageHandlers.closeGachaModal.postMessage('')
      } else {
        console.log('No native APIs found.')
      }
    }
  }
}
